import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useState, useMemo } from 'react'
import { useParams } from 'react-router-dom';

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import CardHeader from '../../containers/CardHeader'
import Form from '../../containers/Form/Form'
import Input from '../../containers/Form/Input'
import Button from '../../containers/Form/Button'
import ConfirmDialog from '../../containers/ConfirmDialog';

import DataTable from "../../containers/DataTable";
import { Card, Row, Col, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../app/settings'
import pathAPICall from '../../app/apiCalls/pathAPICall';
import { path_details, path_cpc_save, path_cpc_delete, path_save } from '../../app/apiEndpoints';
import Select from '../../containers/Form/Select';

const PathsCPCForm = (props) => {
    let { pathType, pathID } = useParams();
    const [path, setPath] = useState({})

    const [defaultCpc, setDefaultCpc]  = useState(0)
    const [defaultUrl, setDefaultUrl]  = useState("")
    const [inputValue, setInputValue] = useState({ subpid: "", revenue: "", url: "", split: "50", active: 1});
    const [errors, setErrors] = useState({ subpid: "", revenue: "", url: "", split: "", defaultCpc: "", defaultUrl: "" });
    const { subpid, revenue, url, split, active } = inputValue;
    const [formMessage, setFormMessage] = useState('')
    const [customFormMessage, setCustomFormMessage] = useState('')
    const [hasErrors, setHasErrors] = useState(false)
    const [hasCustomErrors, setHasCustomErrors] = useState(false)

    const [status, setStatus] = useState(0)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [cpcs, setCpcs] = useState([])
    const [subpids, setSubpids] = useState([])
    const [history, setHistory] = useState([])
    const [curID, setCurID] = useState(-1)

    const tableID = "result"
    const tableFields = ["Subpid", "CPC Rate", "Redirect URL", "Split", "Active?"]
    const historyFields = ["CPC Rate", "Date Set"]

    useMemo(() => {
        const getDetails = async () => {
            if(pathID > 0) {
                const data = await pathAPICall(path_details, {'pathID': pathID, 'requester': userID, 'company': companyID })
                setPath(data.path)
                if(data.path.default_cpc) setDefaultCpc(data.path.default_cpc)
                if(data.path.cpc_url) setDefaultUrl(data.path.cpc_url)
                setCpcs(data.cpcs)
                setSubpids(data.subpids)
                setHistory(data.history)
            }
        }
        getDetails()
    }, [pathID, userID, companyID])

    const tableData = () => {
        if(subpids.length === 0) {
            return [];
        } 

        let rows = [];
        cpcs.forEach(row => {
            rows.push({'id': row.subpid, 'deleteFnc': confirmDeleteSubpid, 'values': [
                row.subpid,
                row.custom_cpc,
                row.redirect_url,
                row.split + '%',
                row.active === '1' ? 'Yes' : 'No'
            ]});
        });
        return rows
    }
    const historyData = () => {
        if(history.length === 0) {
            return [];
        } 

        let rows = [];
        history.forEach(row => {
            rows.push({'id': row.id, 'values': [
                row.cpc_rate,
                row.modified_date
            ]});
        });
        return rows
    }

    const savePath = async (e) => {
        e.preventDefault()
        let formErrors = []
        setHasErrors(false)
        for (const field of Object.entries(errors)) {
            const error = field[1]
            if(error.length > 0) formErrors.push(error)
        }
        if(formErrors.length > 0) { 
            setHasErrors(true)
            setFormMessage(formErrors.join('<br/>'))
            return
        }
        setFormMessage('')

        setStatus(1)

        const data = await pathAPICall(path_save, {
            'requester': userID, 
            'company': companyID, 
            'pathID': pathID,
            'rate': defaultCpc,
            'url': defaultUrl
        })

        //if successful, delete from project object
        if(!data.success && data.error) {
            setFormMessage(data.error)
            setHasErrors(true)
            setStatus(0)
            return
        } 

        if(data.path) {
            setFormMessage("Defaults Saved")
            setPath(data.path)
            setHistory(data.history)
            setStatus(2)
        }
    }

    const saveSubpid = async (e) => {
        e.preventDefault()
        let formErrors = []
        setHasCustomErrors(false)
        for (const field of Object.entries(errors)) {
            const error = field[1]
            if(error.length > 0) formErrors.push(error)
        }
        if(formErrors.length > 0) { 
            setHasCustomErrors(true)
            setCustomFormMessage(formErrors.join('<br/>'))
            return
        }
        setCustomFormMessage('')

        setStatus(1)

        const data = await pathAPICall(path_cpc_save, {
            'requester': userID, 
            'company': companyID, 
            'pathID': pathID,
            'subpid': subpid,
            'rate': revenue, 
            'url': url,
            'split': split,
            'active': active
        })

        //if successful, delete from project object
        if(!data.success && data.error) {
            setCustomFormMessage(data.error)
            setHasCustomErrors(true)
            setStatus(0)
            return
        } 

        if(data.cpcs) {
            setCustomFormMessage("CPC Revenue Saved")
            setCpcs(data.cpcs)
            setStatus(2)
        }
    }

    const confirmDeleteSubpid = (e) => {
        e.preventDefault()
        console.log(e)
        let rowID = e.target.id
        rowID = rowID.replace(`delete_`, "")
        if((rowID).length > 0) {
            setCurID((rowID))
            setShowConfirmDelete(true)
        }
    }

    const deleteSubpid = async (e) => {
        setShowConfirmDelete(false)
        if(curID <= 0) return;
        const data = await pathAPICall(path_cpc_delete, {
            'requester': userID, 
            'company': companyID, 
            'pathID': pathID,
            'subpid': curID
        })

        //if successful, delete from project object
        if(!data.success && data.error) {
            setFormMessage(data.error)
            setHasErrors(true)
            return
        } 
        console.table(data)

        if(data.cpcs) {
            setCustomFormMessage("Custom CPC Deleted")
            setCpcs(data.cpcs)
        }
    }

    const newSubpid = (e) => {
        const matched = cpcs.find(obj => obj.subpid === e.target.value);

        setInputValue((prev) => ({
            subpid: e.target.value, revenue: (matched ? matched.custom_cpc : ''), 
            url: (matched ? matched.redirect_url : ''), 
            split: (matched ? matched.split : '50'), 
            active: (matched ? matched.active : 1)
        }));
        setFormMessage("")
        setStatus(0)
    }

    const handleChange = (e) => {
        console.log(e)
        let { name, value } = e.target;

        setInputValue((prev) => ({
          ...prev,
          [name]: value,
        }));
    };

    const changeCPC = (e) => {
        let { name, value } = e.target;
        if(name === "default_url") setDefaultUrl(value)
       else if(name === "default_cpc") setDefaultCpc(value)
    }
    
    const handleError = (field, error) => {
        setErrors((prev) => ({
            ...prev,
            [field]: error,
        }));
    };

    const pathName = () => {
        var str = pathType ?? ''
        return str.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') + ' Paths';
      }

    if(!path) return <></>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/paths/">Paths</Breadcrumb.Item>
          <Breadcrumb.Item href={`/paths/${pathType}/`}>{pathName()}</Breadcrumb.Item>
          <Breadcrumb.Item active>{path.path}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
            <Row>
                <Col md={6}>
                    <Form title={path.path} description="Configure Default CPC rate" onSubmit={savePath} noCard={true}>  
                    <Card.Body>
                            <Input
                                type="text"
                                value={defaultCpc}
                                placeholder="Default CPC"
                                label="Default CPC"
                                name="default_cpc"
                                onChange={changeCPC}
                                onError={handleError}
                                validate="text"
                                colSize="6"
                                readOnly={status !== 0}
                            />
                            <Input
                                type="url"
                                value={defaultUrl}
                                placeholder="Default Redirect URL"
                                label="Default Redirect URL"
                                name="default_url"
                                onChange={changeCPC}
                                onError={handleError}
                                validate="url"
                                colSize="8"
                                readOnly={status !== 0}
                            />
                                    <Card.Text className={hasErrors ? "text-danger" : "text-success"}>{formMessage}</Card.Text>
                                    {status === 0 ? <Button title="Update Defaults" className="primary" /> : null}
                        </Card.Body>
                        </Form>
                    </Col>
                    <Col md={6}>
                    <CardHeader title="CPC History" description="History of default CPC rates" />
                    <DataTable hover={false} tableID="history" fieldNames={historyFields} dataRows={historyData()} tableSettings={tableTypes.None} />
                    </Col>
                </Row>
            </Card>
            <Row>
                <Col md={6}>
                <Card>
                <CardHeader title="Custom CPCs" description="Configured Subpid CPCs" />
                <DataTable hover={false} tableID={tableID} fieldNames={tableFields} dataRows={tableData()} tableSettings={tableTypes.None} />
                </Card>
                </Col>
                <Col md={6}>

            <Card>
            <Form description="Configure custom CPC values" onSubmit={saveSubpid} noCard={true}>  
            <Card.Body>
                <Select 
                    value={subpid} 
                    label="Subpid" 
                    name="subpid" 
                    onChange={newSubpid} 
                    onError={handleError} 
                    validate="required|text" 
                    colSize={8} 
                    formValues={subpids} 
                    useDefault={true} />

                <Input
                    type="text"
                    value={revenue}
                    placeholder="Revenue"
                    label="Revenue"
                    name="revenue"
                    onChange={handleChange}
                    onError={handleError}
                    validate="decimal|required"
                    colSize="8"
                    readOnly={status !== 0}
                />
                <Input
                    type="url"
                    value={url}
                    placeholder="Redirect URL"
                    label="Redirect URL"
                    name="url"
                    onChange={handleChange}
                    onError={handleError}
                    validate="url|required"
                    colSize="8"
                    readOnly={status !== 0}
                />
                <Input
                    type="number"
                    value={split}
                    placeholder="Split %"
                    label="Split %"
                    name="split"
                    onChange={handleChange}
                    onError={handleError}
                    validate="number|required"
                    colSize="8"
                    readOnly={status !== 0}
                />
                <Select 
                    value={active} 
                    label="Active" 
                    name="active" 
                    onChange={handleChange} 
                    onError={handleError} 
                    colSize={8} 
                    formField="yesno" 
                    useDefault={false} />
                <Row>
                    <Col className="text-center">
                        <Card.Text className={hasCustomErrors ? "text-danger" : "text-success"}>{customFormMessage}</Card.Text>
                        <Button title="Save Custom Rate" className="primary" />
                    </Col>
                </Row>
            </Card.Body>
            </Form>
            </Card>
            <ConfirmDialog
                show={showConfirmDelete}
                title="Delete Subpid" message="Are you sure you wish to delete this Custom CPC?"
                onClose={() => { setShowConfirmDelete(false) }}
                onConfirm={deleteSubpid}
            />
            </Col>
            </Row>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(PathsCPCForm), "Path Management"));